<template>
    <div class="checkout-forms">

        <h2 style="font-weight: bold" v-if="!isEditMode">step.1（在庫確認）</h2>

        <div class="row mb25">
            <div v-if="!isEditMode">
                <div class="col-md-6 form-group">
                    <label>氏(family name)<span class="text-danger">※必須</span></label>
                    <input
                        name="family_name"
                        type="text"
                        class="form-control"
                        v-model="orderForm.familyName"
                        @change="update"
                    />
                    <has-error :form="orderForm.form" field="family_name"></has-error>
                </div>
                <div class="col-md-6 form-group">
                    <label>名(first name)<span class="text-danger">※必須</span></label>
                    <input
                        name="first_name"
                        type="text"
                        class="form-control"
                        v-model="orderForm.firstName"
                        @change="update"
                    />
                    <has-error :form="orderForm.form" field="first_name"></has-error>
                </div>
            </div>
            <div class="col-md-12 form-group">
                <label class="col-md-12 p-0">利用先都道府県<span class="text-danger">※必須</span></label>
                <p>※北海道・沖縄・離島の場合はお届けが難しい場合がございますのでご了承ください。</p>
                <div class="col-md-6 p-0">
                    <select
                        name="usage_prefecture"
                        class="form-control"
                        v-model="orderForm.usagePrefecture"
                        @change="update"
                    >
                        <option v-for="prefecture in prefectures" :value="prefecture">{{ prefecture }}</option>
                    </select>
                    <has-error :form="orderForm.form" field="usage_prefecture"></has-error>
                </div>
            </div>
            <div class="col-md-12 form-group">
                <label class="col-md-12 p-0">
                    納品希望日<span class="text-danger">※必須</span>
                    <span class="link">レンタル期間については<a href="/pdf/partycreation_rentalkikan.pdf" target="_blank">コチラ</a></span>
                </label>

                <div class="col-md-6 p-0">
                    <date-picker
                        :input-attr="{name: 'delivery_date'}"
                        style="width: 100%; font-family: sans-serif;"
                        input-class="form-control"
                        v-model="orderForm.deliveryDate"
                        @input="update"
                        @change="changeDeliveryDate"
                        format="YYYY/MM/DD"
                        value-type="YYYY-MM-DD"
                        :min="today"
                    />
                    <has-error :form="orderForm.form" field="delivery_date"></has-error>
                </div>
                <div
                    v-if="deliveryDateAlert"
                    class="col-md-12 alert alert-danger mb0 mt5"
                    role="alert">
                    {{ deliveryDateAlert }}
                </div>
            </div>
            <div class="col-md-12 form-group">
                <label class="col-md-12 p-0">返却発送日<span class="text-danger">※必須</span></label>
                <div class="col-md-6 p-0">
                    <date-picker
                        :input-attr="{name: 'return_date'}"
                        value-type="YYYY-MM-DD"
                        style="width: 100%; font-family: sans-serif;"
                        input-class="form-control"
                        v-model="orderForm.returnDate"
                        @input="update"
                        @change="changeReturnDate"
                        format="YYYY/MM/DD"
                    />
                    <has-error :form="orderForm.form" field="return_date"></has-error>
                </div>
                <div
                    v-if="returnDateAlert"
                    class="col-md-12 alert alert-danger mb0 mt5"
                    v-text="returnDateAlert"
                    role="alert">
                </div>
            </div>

            <div class="col-md-12 pt20 pb20" v-if="!isEditMode">
                <button
                    type="button"
                    class="btn btn-primary min-width"
                    @click="onStockCheck"
                >
                    在庫確認のみ依頼
                </button>
                <p class="mb0">お見積りをご希望のお客様はこのままstep.2へとお進みください</p>
            </div>
        </div>

        <h2 style="font-weight: bold" v-if="!isEditMode">step.2（見積り依頼）</h2>
        <h2 style="font-weight: bold">【お客様情報（ご請求先）】</h2>
        <div class="row">
            <div class="col-md-12 form-group">
                <label class="">会社名</label>
                <input
                    name="order_company_name"
                    type="text"
                    class="form-control"
                    v-model="orderForm.orderCompanyName"
                    @change="update"
                />
                <has-error :form="orderForm.form" field="order_company_name"></has-error>
            </div>
            <div v-if="isEditMode" class="col-md-12 form-group">
                <label>発注者氏名<span class="text-danger">※必須</span></label>
                <input
                    name="user_name"
                    type="text"
                    class="form-control"
                    v-model="orderForm.userName"
                    @change="update"
                />
                <has-error :form="orderForm.form" field="user_name"></has-error>
            </div>
<!--            <div class="col-md-12 form-group">-->
<!--                <label>お振込名義が異なる場合は下記にご記入ください</label>-->
<!--                <input-->
<!--                    name="payment_name"-->
<!--                    type="text"-->
<!--                    class="form-control"-->
<!--                    v-model="orderForm.paymentName"-->
<!--                    @change="update"-->
<!--                />-->
<!--                <has-error :form="orderForm.form" field="payment_name"></has-error>-->
<!--            </div>-->
            <div class="col-md-12 form-group">
                <label>連絡先電話番号(phone number/ハイフンなし)<span class="text-danger">※必須</span></label>
                <input
                    name="user_phone"
                    type="text"
                    class="form-control"
                    v-model="orderForm.userPhone"
                    @change="update"
                />
                <has-error :form="orderForm.form" field="user_phone"></has-error>
            </div>
            <div class="col-md-12 form-group">
                <address-forms2
                    required
                    label="住所"
                    postType="form"
                    :address-model="orderUserAddressForm"
                    @change="updateUserAddress"
                    name="order_user_address"
                />
            </div>
        </div>
        <div class="row mb15">
            <h2 style="font-weight: bold">【ご利用情報】</h2>

            <div class="col-md-12 form-group">
                <label class="col-md-12 p-0">ご利用日<span class="text-danger">※必須</span></label>
                <div class="col-md-6 p-0">
                    <date-picker
                        :input-attr="{name: 'usage_date'}"
                        input-class="form-control"
                        style="width: 100%; font-family: sans-serif;"
                        v-model="orderForm.usageDate"
                        @input="update"
                        @change="changeUsageDate"
                        format="YYYY/MM/DD"
                        value-type="YYYY-MM-DD"
                    />
                    <has-error :form="orderForm.form" field="usage_date"></has-error>
                </div>
            </div>

            <div class="col-md-12 form-group mb3" v-if="useInfoAlert">
                <div class="alert alert-danger" role="alert">
                    {{ useInfoAlert }}
                </div>
            </div>

<!--            <div class="col-md-6 form-group form-group_time">-->
<!--                <label>ご利用時間</label>-->
<!--                <date-picker-->
<!--                    v-model="orderForm.usageTime"-->
<!--                    name="usage_time"-->
<!--                    input-class="form-control"-->
<!--                    format="HH:mm"-->
<!--                    value-type="format"-->
<!--                    type="time"-->
<!--                    placeholder="&#45;&#45;:&#45;&#45;"-->
<!--                    :minute-step="30"-->
<!--                    :input-attr="{name: 'usage_time'}"-->
<!--                    :editable="false"-->
<!--                    @change="update"-->
<!--                />-->
<!--                <has-error :form="orderForm.form" field="usage_time"></has-error>-->
<!--            </div>-->
<!--            <div class="col-md-12 form-group">-->
<!--                <label>使用予定人数</label>-->
<!--                <input-->
<!--                    name="planned_number"-->
<!--                    type="number"-->
<!--                    class="form-control"-->
<!--                    v-model="orderForm.plannedNumber"-->
<!--                    @change="update"-->
<!--                />-->
<!--                <has-error :form="orderForm.form" field="planned_number"></has-error>-->
<!--            </div>-->
            <div class="col-md-12 form-group">
                <label>ご利用用途<span class="text-danger">※必須</span></label>
                <select
                    name="usage_name"
                    class="form-control"
                    v-model="orderForm.usageName"
                    @change="update"
                >
                    <option :value="null">選択してください</option>
                    <option
                        v-for="item in USAGE_NAME_LIST"
                        :key="item.value"
                        :value="item.value"
                    >
                        {{ item.name }}
                    </option>
                </select>
                <has-error :form="orderForm.form" field="usage_name"></has-error>
            </div>
            <div class="col-md-12 form-group" v-if="showUsageDetail">
                <label>{{ usageDetailLabel }}
                    <span v-if="orderForm.usageName != USAGE_NAME_OTHER" class="text-danger">※必須</span>
                </label>
                <div class="pt7">
                    <textarea
                        name="usage_detail"
                        class="form-control"
                        rows="6"
                        v-model="orderForm.usageDetail"
                        @change="update"
                    />
                    <has-error :form="orderForm.form" field="usage_detail"></has-error>
                </div>
            </div>
        </div>

        <div class="row">
            <h2 style="font-weight: bold">
                【ご納品先情報】
            </h2>
            <div class="col-md-12 form-group address-box">
                <label>納品先住所<span class="text-danger">※必須</span></label>
                <template v-if="orderForm.orderDeliveryAddress.id">
                    <span class="address-change" @click="showAddressModal = true">変更</span>
                    <div class="form-control address-control">
                        {{ orderForm.orderDeliveryAddress.allAddress }}
                    </div>
                    <input
                        name="order_delivery_address_id"
                        v-model="orderForm.orderDeliveryAddress.id"
                        hidden
                        >
                </template>
                <template v-if="!orderForm.orderDeliveryAddress.id">
                    <button
                        type="button"
                        @click="showAddressModal = true"
                        style="display: block;"
                        class="btn btn-accent white">
                        {{ deliveryAddressBtnText }}
                    </button>
                </template>
                <has-error :form="orderForm.form" field="order_delivery_address_id"></has-error>
            </div>
            <div class="col-md-6 form-group">
                <label>納品先電話番号(ハイフンなし)</label>
                <input
                    name="delivery_target_phone_number"
                    type="text"
                    class="form-control"
                    v-model="orderForm.deliveryTargetPhoneNumber"
                    @change="update"
                />
                <has-error :form="orderForm.form" field="delivery_target_phone_number"></has-error>
            </div>

            <div class="col-md-12 form-group">
                <label>納品時間指定希望<span class="text-danger">※必須</span></label>
                <select
                    name="delivery_time_specified"
                    class="form-control"
                    v-model="orderForm.deliveryTimeSpecified"
                    @change="onDeliveryTimeSpecifiedChange"
                >
                    <option
                        v-for="item in getDeliveryTimeSpecifiedOptions"
                        :key="'DELIVERY_TIME_SPECIFIED_LIST'+item.value"
                        :value="item.value"
                    >
                        {{ item.name }}
                    </option>
                </select>
                <has-error class="col-md-12" :form="orderForm.form"
                           field="delivery_time_specified"></has-error>
            </div>

            <div class="col-md-12 form-group">
                <label>
                    納品方法<span class="text-danger">※必須</span>
                    <span class="link">納品については<a href="/pdf/partycreation_haisou.pdf" target="_blank">コチラ</a></span>
                </label>
                <select
                    name="delivery_method"
                    class="form-control"
                    v-model="orderForm.deliveryMethod"
                    @change="onDeliveryMethodChange"
                >
                    <option
                        v-for="item in getArrayDeliveryMethods"
                        :key="'DELIVERY_METHOD_TYPE'+item.value"
                        :value="item.value"
                    >
                        {{ item.name }}
                    </option>
                </select>
                <has-error class="col-md-12" :form="orderForm.form"
                           field="delivery_method"></has-error>
            </div>

            <div class="col-md-12 form-group form-group_time" v-if="showDeliveryTimeDetailForm">
                <label>納品希望時間<span class="text-danger">※必須</span></label>
                <select
                    name="delivery_time_detail"
                    class="form-control"
                    v-model="orderForm.deliveryTimeDetail"
                    @change="update"
                >
                    <option
                        v-for="item in getDeliveryTimeDetailOptions"
                        :key="'DELIVERY_TIME_DETAIL_LIST'+item.value"
                        :value="item.value"
                    >
                        {{ item.name }}
                    </option>
                </select>
                <has-error class="col-md-12" :form="orderForm.form"
                           field="delivery_time_detail"></has-error>
            </div>
            <div class="col-md-12 form-group" v-if="showCarriedSupportForm">
                <label>搬入サポート<span class="text-danger">※必須</span></label>
                <select
                    name="carried_support"
                    class="form-control"
                    v-model="orderForm.carriedSupport"
                    @change="update"
                >
                    <option
                        v-for="item in CARRIED_SUPPORT_LIST"
                        :key="'CARRIED_SUPPORT_LIST'+item.value"
                        :value="item.value"
                    >
                        {{ item.name }}
                    </option>
                </select>
                <has-error class="col-md-12" :form="orderForm.form"
                           field="carried_support"></has-error>
            </div>
            <div class="col-md-12 form-group">
<!--                <p class="mb5">受け取り者が注文者と異なる場合、下記にご記入ください。</p>-->
                <label>担当者名<span class="text-danger">※必須</span></label>
                <input
                    name="delivery_person_name"
                    class="form-control"
                    type="text"
                    v-model="orderForm.deliveryPersonName"
                    @change="update"
                />
                <has-error :form="orderForm.form" field="delivery_person_name"></has-error>
            </div>
            <div class="col-md-12 form-group">
                <label>担当者連絡先<span class="text-danger">※必須</span></label>
                <input
                    name="delivery_person_tel"
                    class="form-control"
                    type="text"
                    v-model="orderForm.deliveryPersonTel"
                    @change="update"
                />
                <has-error :form="orderForm.form" field="delivery_person_tel"></has-error>
            </div>
<!--            <div class="col-md-12 form-group">-->
<!--                <label>その他注意事項</label>-->
<!--                <textarea-->
<!--                    name="delivery_target_other"-->
<!--                    class="form-control"-->
<!--                    rows="10"-->
<!--                    v-model="orderForm.deliveryTargetOther"-->
<!--                    @change="update"-->
<!--                />-->
<!--                <has-error :form="orderForm.form" field="delivery_target_other"></has-error>-->
<!--            </div>-->
        </div>
        <div class="row">
            <h2 style="font-weight: bold">
                【ご返却情報】
            </h2>
            <div class="col-md-12 form-group">
                <label>
                    返却方法<span class="text-danger">※必須</span>
                </label>
                <select
                    name="return_method"
                    class="form-control"
                    v-model="orderForm.returnMethod"
                    @change="onReturnMethodChange"
                >
                    <option
                        v-for="item in getArrayReturnMethods"
                        :key="'DELIVERY_METHOD_TYPE'+item.value"
                        :value="item.value"
                    >
                        {{ item.name }}
                    </option>
                </select>
                <has-error class="col-md-12" :form="orderForm.form" field="return_method"></has-error>
            </div>
            <div v-if="showReturnTimeSpecifiedForm" class="col-md-12 form-group">
                <label>返却時間指定希望<span class="text-danger">※必須</span></label>
                <select
                    name="return_time_specified"
                    class="form-control"
                    v-model="orderForm.returnTimeSpecified"
                    @change="update"
                >
                    <option
                        v-for="item in getReturnTimeSpecifiedOptions"
                        :key="'RETURN_TIME_SPECIFIED_LIST'+item.value"
                        :value="item.value"
                    >
                        {{ item.name }}
                    </option>
                </select>
                <has-error :form="orderForm.form" field="return_time_specified"></has-error>
            </div>
            <div class="col-md-12 form-group form-group_time" v-if="showReturnTimeDetailForm">
                <label>返却希望時間<span class="text-danger">※必須</span></label>
                <select
                    name="return_time_detail"
                    class="form-control"
                    v-model="orderForm.returnTimeDetail"
                    @change="update"
                >
                    <option
                        v-for="item in getReturnTimeDetailOptions"
                        :key="'RETURN_TIME_DETAIL_LIST'+item.value"
                        :value="item.value"
                    >
                        {{ item.name }}
                    </option>
                </select>
                <has-error class="col-md-12" :form="orderForm.form"
                           field="return_time_detail"></has-error>
            </div>
            <div class="col-md-12 form-group" v-if="showCarryOutSupportForm">
                <label>搬出サポート<span class="text-danger">※必須</span></label>
                <select
                    name="carry_out_support"
                    class="form-control"
                    v-model="orderForm.carryOutSupport"
                    @change="update"
                >
                    <option
                        v-for="item in CARRIED_SUPPORT_LIST"
                        :key="'CARRY_OUT_SUPPORT_LIST'+item.value"
                        :value="item.value"
                    >
                        {{ item.name }}
                    </option>
                </select>
                <has-error class="col-md-12" :form="orderForm.form"
                           field="carry_out_support"></has-error>
            </div>
            <div class="col-md-12 form-group">
                <p class="mb5">返却者が注文者と異なる場合、下記にご記入ください。</p>
                <label>返却担当者氏名</label>
                <input
                    name="return_person_name"
                    class="form-control"
                    type="text"
                    v-model="orderForm.returnPersonName"
                    @change="update"
                />
                <has-error :form="orderForm.form" field="return_person_name"></has-error>
            </div>
            <div class="col-md-12 form-group">
                <label>返却担当者連絡先</label>
                <input
                    name="return_person_tel"
                    class="form-control"
                    type="text"
                    v-model="orderForm.returnPersonTel"
                    @change="update"
                />
                <has-error :form="orderForm.form" field="return_person_tel"></has-error>
            </div>
<!--            <div class="col-md-12 form-group">-->
<!--                <label>その他注意事項</label>-->
<!--                <textarea-->
<!--                    name="return_target_other"-->
<!--                    class="form-control"-->
<!--                    rows="10"-->
<!--                    v-model="orderForm.returnTargetOther"-->
<!--                    @change="update"-->
<!--                />-->
<!--                <has-error :form="orderForm.form" field="return_target_other"></has-error>-->
<!--            </div>-->
            <div class="col-md-12 form-group">
                <label>備考</label>
                <textarea
                    name="remarks"
                    class="form-control"
                    rows="10"
                    v-model="orderForm.remarks"
                    @change="update"
                />
                <has-error :form="orderForm.form" field="remarks"></has-error>
            </div>
            <div v-if="!isEditMode" class="col-md-6 form-group">
                <label>クーポンコード</label>
                <input
                    name="coupon_code"
                    class="form-control"
                    type="text"
                    v-model="orderForm.coupon.code"
                    @change="update"
                />
                <has-error :form="orderForm.form" field="coupon_code"></has-error>
            </div>

            <div v-if="isEditMode&&isCouponForm" class="col-md-6 form-group">
                <label>クーポンコード</label>
                <input
                    class="form-control"
                    type="text"
                    v-model="orderForm.couponId"
                    @change="update"
                />
                <has-error :form="orderForm.form" field="coupon_id"></has-error>
            </div>



        </div>

        <address-select-modal
            v-if="showAddressModal"
            :delivery-address="orderForm.orderDeliveryAddress"
            @close="showAddressModal = false"
            @change="(val) => changeDeliveryAddress(val)"
        ></address-select-modal>
    </div>
</template>

<script>
import {HasError} from "vform";
import OrderHistory, {
    DELIVERY_METHOD_DELIVER_SAGAWA,
    DELIVERY_METHOD_DELIVER_YAMATO,
    DELIVERY_METHOD_TYPE_LIST,
    DELIVERY_TIME_SPECIFIED_FALSE,
    DELIVERY_TIME_SPECIFIED_LIST,
    RETURN_METHOD_TYPE_LIST,
    RETURN_TIME_SPECIFIED_LIST,
    USAGE_NAME_LIST,
    DELIVERY_TIME_DETAIL_LIST,
    RETURN_TIME_DETAIL_LIST,
    RETURN_TIME_SPECIFIED_FALSE,
    DELIVERY_TIME_SPECIFIED_TRUE_TAKE_OFF,
    RETURN_TIME_SPECIFIED_TRUE_TAKE_OFF,
    RETURN_METHOD_DELIVER_SAGAWA,
    USAGE_NAME_OTHER,
    DELIVERY_TIME_SPECIFIED_TRUE,
    CARRIED_SUPPORT_LIST, RETURN_METHOD_DELIVER_CHARTER,
} from "../../models/OrderHistory";
import {dateFormat} from "../../utility/dateUtility";
import {ORDER_STATUS_LIST} from "../../const/OrderConstant";
import dateConfig from "../../const/admin/dateConfig";
import CheckoutService from "../../services/CheckoutService";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from "moment";
import 'vue2-datepicker/locale/ja';
import AddressForms2 from "./AddressForms2";
import UserAddress from "../../models/UserAddress";
import AddressSelectModal from "../AddressSelectModal";
import {PREFECTURES} from "../../const/prefectures";

export default {
    name: 'checkout-forms',

    data() {
        return {
            orderForm: new OrderHistory(),
            orderUserAddressForm: new UserAddress(),
            prefectures: PREFECTURES,
            dateFormat,
            USAGE_NAME_LIST,
            USAGE_NAME_OTHER,
            ORDER_STATUS_LIST,
            DELIVERY_TIME_SPECIFIED_LIST,
            DELIVERY_METHOD_TYPE_LIST,
            RETURN_TIME_SPECIFIED_LIST,
            DELIVERY_TIME_DETAIL_LIST,
            RETURN_TIME_DETAIL_LIST,
            CARRIED_SUPPORT_LIST,
            dateConfig,
            today: moment().format('YYYY-MM-DD'),
            showAddressModal: false,
            useInfoAlert: '', // ご利用情報アラート
            deliveryDateAlert: '', // 納品希望日アラート
            returnDateAlert: '', // 返却希望日アラート
            couponCode: '',
        }
    },

    props: {
        value: {
            type: OrderHistory,
            required: true,
        },
        isCartInCharterOnly: {
            type: Boolean,
            default: false,
        },
        isEditMode: {
            type: Boolean,
            default: false,
        }
    },

    watch: {
        value(val) {
            this.orderForm = new OrderHistory({...val})
            this.orderUserAddressForm = new UserAddress({...this.orderForm.orderUserAddress})
            this.$nextTick()
        }
    },

    computed: {
        getArrayDeliveryMethods() {
            return CheckoutService.getDeliveryMethodOptions(this.orderForm.deliveryTimeSpecified, this.isCartInCharterOnly)
        },
        getDeliveryTimeSpecifiedOptions() {
            let placeHolder = [{value:'', name: '選択してください'}]
            if(this.isCartInCharterOnly) {
                const arr = DELIVERY_TIME_SPECIFIED_LIST.filter(x => x.value === DELIVERY_TIME_SPECIFIED_TRUE)
                return placeHolder.concat(arr)
            }
            return placeHolder.concat(DELIVERY_TIME_SPECIFIED_LIST)
        },
        getReturnTimeSpecifiedOptions() {
            let placeHolder = [{value:'', name: '選択してください'}]
            let arr = this.RETURN_TIME_SPECIFIED_LIST
            if(this.orderForm.deliveryTimeSpecified === DELIVERY_TIME_SPECIFIED_TRUE_TAKE_OFF) {
                arr = arr.filter(x => x.value === RETURN_TIME_SPECIFIED_TRUE_TAKE_OFF)
            }
            return placeHolder.concat(arr)
        },
        getDeliveryTimeDetailOptions() {
            return CheckoutService.getTimeDetailSelectOptions(this.orderForm.deliveryMethod, this.isCartInCharterOnly)
        },
        getReturnTimeDetailOptions() {
            return CheckoutService.getReturnTimeDetailOptions(this.orderForm.returnMethod, this.isCartInCharterOnly)
        },
        getArrayReturnMethods() {
            let placeHolder = [{value:'', name: '選択してください'}]
            if(!this.orderForm.deliveryMethod) {
                placeHolder = [{value:'', name: '先に納品方法を入力してください'}]
            }
            const arr =  RETURN_METHOD_TYPE_LIST.filter(x => {
                if(this.orderForm.deliveryMethod === DELIVERY_METHOD_DELIVER_YAMATO) {
                    return x.value === DELIVERY_METHOD_DELIVER_SAGAWA
                }
                return x.value === this.orderForm.deliveryMethod
            })
            if(!this.orderForm.deliveryMethod) return placeHolder.concat(arr)
            if (CheckoutService.isMethodTypeReceiver(this.orderForm.deliveryMethod)) {
                arr.push(RETURN_METHOD_TYPE_LIST.find(item => item.value === DELIVERY_METHOD_DELIVER_SAGAWA))
            }
            return placeHolder.concat(arr)
        },
        showUsageDetail() {
            return this.orderForm.usageName !== null
            // if (this.orderForm.usageName === null) return false
            // return CheckoutService.isShowUsageDetailForm(this.orderForm.usageName)
        },
        usageDetailLabel() {
            if(!this.orderForm.usageName) return ''
            return CheckoutService.getUsageDetailFormLabel(this.orderForm.usageName)
        },
        showDeliveryTimeDetailForm() {
            if(!this.orderForm.deliveryTimeSpecified) return false
            return CheckoutService.isShowDeliveryTimeDetailForm(this.orderForm.deliveryTimeSpecified)
        },
        showReturnTimeSpecifiedForm() {
            if(!this.orderForm.returnMethod) return false
            return CheckoutService.isShowReturnTimeSpecifiedForm(this.orderForm.returnMethod)
        },
        showReturnTimeDetailForm() {
            if(this.orderForm.returnMethod === RETURN_METHOD_DELIVER_CHARTER) {
                return true
            }
            if(!this.orderForm.returnTimeSpecified) return false
            return CheckoutService.isShowReturnTimeDetailForm(this.orderForm.returnTimeSpecified)
        },
        deliveryAddressBtnText() {
            return !this.orderForm.user.deliveryAddresses.length ? '+新しい住所を登録する' : '住所を選択する'
        },
        showCarriedSupportForm() {
            return CheckoutService.isShowCarriedSupportForm(this.orderForm.deliveryMethod)
        },
        showCarryOutSupportForm() {
            return CheckoutService.isShowCarryOutSupportForm(this.orderForm.returnMethod)
        },
        isCouponForm() {
            return !!this.orderForm.isStockCheckOnly
        },
    },

    created() {
    },

    mounted() {
    },

    methods: {
        update() {
            this.$emit('change', this.orderForm)
        },

        updateUserAddress(address) {
            this.orderForm.orderUserAddress = new UserAddress({...address})
            this.$emit('change', this.orderForm)
        },

        changeUsageDate(val) {
            this.useInfoAlert = CheckoutService.isUsageDateAlert(val)
        },

        changeDeliveryDate(val) {
            this.deliveryDateAlert = CheckoutService.isDeliveryDateAlert(val)
            // 宅配の時は返却は佐川固定
            this.orderForm.returnMethod = this.orderForm.deliveryMethod
            if(this.orderForm.deliveryMethod === DELIVERY_METHOD_DELIVER_YAMATO) {
                this.orderForm.returnMethod = DELIVERY_METHOD_DELIVER_SAGAWA
            }
            this.$nextTick()
        },

        changeReturnDate(val) {
            this.returnDateAlert = CheckoutService.isReturnDateAlert(this.orderForm.deliveryDate, val)
        },

        // 納品時間指定希望変更時
        async onDeliveryTimeSpecifiedChange() {
            this.orderForm.deliveryMethod = ''
            this.orderForm.returnMethod = ''
            this.orderForm.returnTimeDetail = ''
            if(this.orderForm.deliveryTimeSpecified === DELIVERY_TIME_SPECIFIED_TRUE_TAKE_OFF) {
                this.orderForm.returnTimeSpecified = DELIVERY_TIME_SPECIFIED_TRUE_TAKE_OFF
            } else {
                this.orderForm.returnTimeSpecified = ''
            }
            await this.$nextTick()
            this.update()
        },

        // 納品方法変更時
        async onDeliveryMethodChange() {
            // ヤマトの時は返却は佐川固定
            this.orderForm.returnMethod = this.orderForm.deliveryMethod
            this.orderForm.carriedSupport = 0
            this.orderForm.carryOutSupport = 0
            if(this.orderForm.deliveryMethod === DELIVERY_METHOD_DELIVER_YAMATO) {
                this.orderForm.returnMethod = DELIVERY_METHOD_DELIVER_SAGAWA
            }
            // 佐川の時は納品時間指定はなし固定・返却方法も同様
            if(this.orderForm.deliveryMethod === DELIVERY_METHOD_DELIVER_SAGAWA) {
                this.orderForm.deliveryTimeSpecified = DELIVERY_TIME_SPECIFIED_FALSE
                this.orderForm.returnTimeSpecified = RETURN_TIME_SPECIFIED_FALSE
                this.orderForm.deliveryTimeDetail = ''
                this.orderForm.returnTimeDetail = ''
            }
            // 引取りの時
            if(CheckoutService.isMethodTypeReceiver(this.orderForm.deliveryMethod)) {

            }

            await this.$nextTick()
            this.update()
        },

        // 返却方法変更時
        async onReturnMethodChange() {
            if(this.orderForm.returnMethod === RETURN_METHOD_DELIVER_SAGAWA) {
                this.orderForm.returnTimeSpecified = ''
            }
            await this.$nextTick()
            this.update()
        },

        // 納品先住所変更
        changeDeliveryAddress(address) {
            this.orderForm.orderDeliveryAddress = {...address}
            this.update()
        },

        onStockCheck() {
          this.$emit('stock-check')
        },
    },

    components: {
        AddressSelectModal,
        AddressForms2,
        HasError,
        DatePicker,
    }
}
</script>

<style lang="scss" scoped>
.checkout-forms {
    .form-control {
        height: 45px;
        padding: 9.5px 13px;
    }
    .checkout-title {
        padding: 50px;
        @media screen and (max-width: 768px) {
            padding: 30px 0;
        }
    }
    .form-group {
        label {
            font-weight: bold;
        }
        &_time {
            display: flex;
            flex-direction: column;
        }
    }

    .address-change {
        cursor: pointer;
        margin-left: 10px;
        text-decoration-line: underline;
        font-weight: bold;
    }

    .link {
        font-size: 13px;
        font-weight: normal;
        padding-left: 20px;
        a {
            text-decoration: underline;
            font-weight: bold;
        }
    }

    .address-control {
        background-color: #fff;
        border: 1px solid #000;
        float: none;
        box-shadow: none;
        border-radius: 5px;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0.05em;
        height: auto !important;
        padding: 9.5px 13px;
        margin: 0;
        color: #717179;
        line-height: 1.5;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/checkout/CheckoutForms.vue